<template>
  <multi-list-select
    :list="selects"
    :selected-items="items"
    option-value="id"
    option-text="customerable"
    :custom-text="getCustomerName"
    :isDisabled="disabled"
    placeholder="Selecione clientes"
    @select="onSelect"
  >
  </multi-list-select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';
import MultiListSelect from 'vue-search-select/src/lib/MultiListSelect';

export default {
  name: 'SelectCustomersMultiple',
  components: { MultiListSelect },
  data() {
    return {
      selects: [],
      items: [],
      lastSelectItem: {},
    };
  },
  props: {
    disabled: {
      type: Boolean,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/customer/listFiltered?status=1,3`).then(
        (res) => (this.selects = res.data)
      );
    },
    getCustomerName(customer) {
      return `${customer.id} - ` + `${customer.customerable.name}`;
    },
    onSelect(items, lastSelectItem) {
      this.items = items;
      this.$emit(
        'selected',
        items.map((item) => item.id)
      );
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
